import React, { lazy, Suspense } from "react";

const RemoteTrustpilot = lazy(() =>
  import("@/shared/components/TrustPilot/TrustPilotComponents").then((module) => ({
    default: module.TrustPilotWidget,
  }))
);

const Trustpilot = (props: Remote.Trustpilot) => {
  return (
    <Suspense>
      <RemoteTrustpilot {...props} />
    </Suspense>
  );
};

export default Trustpilot;
